import { useState } from 'react';
import { PAYMENT_STAGES } from '..';

const usePaymentStage = (initialStage = PAYMENT_STAGES.REQUIRES_PAYMENT_METHOD) => {
  const [paymentStage, goToPaymentStage] = useState(initialStage);

  return { paymentStage, goToPaymentStage };
};

export default usePaymentStage;
